import { useEffect, useState, type ReactNode } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { App } from "./App";
import { Booking } from "./pages/Booking";
import { Admin } from "./pages/Admin";
import { Intake } from "./pages/Intake";
import { Home } from "./pages/Home";
import { Login } from "./pages/Login";
import { ClientDashboard } from "./pages/ClientDashboard";
import { NewRequest } from "./pages/NewRequest";
import { Leads } from "./pages/admin/Leads";
import { ClientDetail } from "./pages/admin/ClientDetail";
import { Portfolio } from "./pages/Portfolio";
import { PortfolioCase } from "./pages/PortfolioCase";
import { ClientIntelligence } from "./pages/ClientIntelligence";
import { GrauProposal } from "./pages/GrauProposal";
import { getSession } from "./lib/session";
import { LangContext, loadLang, saveLang, type Lang } from "./i18n";

function RequireClient({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [status, setStatus] = useState<"loading" | "authed" | "anon">("loading");
  useEffect(() => { let cancelled=false; getSession().then((session)=>{if(!cancelled)setStatus(session?"authed":"anon")}); return()=>{cancelled=true}; }, []);
  if (status === "loading") return null;
  return status === "authed" ? <>{children}</> : <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
}

export function AppRouter() {
  const [lang, setLangState] = useState<Lang>(() => loadLang());
  const setLang = (l: Lang) => {
    saveLang(l);
    setLangState(l);
  };

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/agenda" element={<App admin={false}><Intake /></App>} />
          <Route path="/login" element={<App admin={false}><Login /></App>} />
          <Route path="/signup" element={<Navigate to="/" replace />} />
          <Route path="/app" element={<App admin={false}><RequireClient><ClientDashboard /></RequireClient></App>} />
          <Route path="/app/intelligence" element={<RequireClient><ClientIntelligence /></RequireClient>} />
          <Route path="/app/book" element={<App admin={false}><RequireClient><Booking /></RequireClient></App>} />
          <Route path="/app/new-request" element={<App admin={false}><RequireClient><NewRequest /></RequireClient></App>} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:slug" element={<PortfolioCase />} />
          <Route path="/proposta-grau-sorocaba" element={<GrauProposal />} />
          <Route path="/admin" element={<App admin={true}><Admin /></App>} />
          <Route path="/admin/leads" element={<App admin={true}><Leads /></App>} />
          <Route path="/admin/clients/:id" element={<App admin={true}><ClientDetail /></App>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </LangContext.Provider>
  );
}
